var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-box", staticStyle: { overflow: "hidden" } },
    [
      !_vm.MENUCONFIG.STYLE.isTop
        ? _c(
            "div",
            { staticClass: "left-box" },
            [
              _c(
                "a-layout",
                [
                  _c(
                    "a-layout-header",
                    {
                      staticStyle: {
                        "border-bottom": "1px solid #e8e8e8",
                        overflow: "hidden",
                        "z-index": "999",
                        "box-shadow": "0px 0px 6px 3px rgb(204 204 204 / 25%)"
                      },
                      style: {
                        "background-color":
                          _vm.MENUCONFIG.STYLE.backgroundColor,
                        color: _vm.MENUCONFIG.STYLE.color
                      }
                    },
                    [
                      _c("div", { staticClass: "spaceBetween header-main" }, [
                        _c("div", { staticClass: "spaceLeft" }, [
                          _c("div", { staticClass: "menu-logo spaceLeft" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/nylogo.png"),
                                alt: "",
                                srcset: "",
                                height: "40"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "text-size-14 time-text",
                              staticStyle: { "margin-left": "15px" }
                            },
                            [
                              _vm._v(
                                "\n                上次登录：" +
                                  _vm._s(
                                    _vm
                                      .moment(_vm.getSessionData.lastLoginTime)
                                      .format("YYYY-MM-DD HH:mm:ss")
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "spaceLeft",
                            staticStyle: { "min-width": "240px" }
                          },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "bottom" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    "\n\t\t          \t\t帮助中心\n\t\t\t\t        "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  staticStyle: {
                                    color: "#505766",
                                    "font-size": "18px",
                                    "margin-right": "26px",
                                    cursor: "pointer"
                                  },
                                  attrs: { type: "question-circle" },
                                  on: { click: _vm.toHelp }
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-right": "15px" } },
                              [
                                _c(
                                  "a-badge",
                                  {
                                    attrs: {
                                      count:
                                        _vm.$store.getters[
                                          "home/getMessageCount"
                                        ] &&
                                        _vm.$store.getters[
                                          "home/getMessageCount"
                                        ].total,
                                      offset: [10, -2]
                                    }
                                  },
                                  [
                                    _c("a-icon", {
                                      staticStyle: { "font-size": "16px" },
                                      attrs: { type: "bell" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _vm._v(" "),
                            _c(
                              "a-dropdown",
                              {
                                staticClass: "user-box",
                                staticStyle: { "margin-left": "20px" },
                                attrs: { placement: "bottomLeft" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pointer" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icon",
                                        staticStyle: { "font-size": "16px" },
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href":
                                              "#gold-icon-yonghuming"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.userObj.userName ||
                                            _vm.userObj.name ||
                                            "用户名称"
                                        ) +
                                        " "
                                    ),
                                    _c("a-icon", { attrs: { type: "down" } })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-menu",
                                  {
                                    attrs: { slot: "overlay" },
                                    slot: "overlay"
                                  },
                                  [
                                    _c("a-menu-item", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:;" },
                                          on: { click: _vm.roleShowInit }
                                        },
                                        [_vm._v("角色切换")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("a-menu-item", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:;" },
                                          on: { click: _vm.toSecurity }
                                        },
                                        [_vm._v("安全中心")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("a-menu-item", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:;" },
                                          on: { click: _vm.logout }
                                        },
                                        [_vm._v("退出登录")]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-layout",
                    [
                      _c(
                        "a-layout-sider",
                        {
                          style: {
                            "background-color":
                              _vm.MENUCONFIG.STYLE.backgroundColor
                          },
                          attrs: { trigger: null, collapsible: "" },
                          model: {
                            value: _vm.leftSideHide,
                            callback: function($$v) {
                              _vm.leftSideHide = $$v
                            },
                            expression: "leftSideHide"
                          }
                        },
                        [
                          _c("div", { staticClass: "left-scroll-box" }, [
                            _c(
                              "div",
                              {
                                staticStyle: { width: "200px", height: "100%" }
                              },
                              [
                                _c("menu-tree", {
                                  ref: "menuTree",
                                  attrs: {
                                    menuData: _vm.menuData,
                                    activeIndex: _vm.activeIndex,
                                    activeOpenIndex: _vm.activeOpenIndex
                                  },
                                  on: { handleSelect: _vm.handleSelect }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.MENUCONFIG.STYLE.isTab
                        ? _c(
                            "a-layout-content",
                            [
                              _c(
                                "a-tabs",
                                {
                                  attrs: {
                                    "hide-add": "",
                                    type: "editable-card",
                                    size: "small"
                                  },
                                  on: {
                                    edit: _vm.removeOneTab,
                                    change: _vm.handleTabSelect,
                                    contextmenu: function($event) {
                                      $event.preventDefault()
                                      return _vm.showTabOperFun($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.activeIndex,
                                    callback: function($$v) {
                                      _vm.activeIndex = $$v
                                    },
                                    expression: "activeIndex"
                                  }
                                },
                                _vm._l(_vm.openedTabBar, function(item) {
                                  return _c("a-tab-pane", {
                                    key: item.menuCode,
                                    attrs: {
                                      tab: item.menuName,
                                      closable: item.menuCode != "gongzuotai"
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bottom-btn",
                  class: { small: _vm.leftSideHide }
                },
                [
                  _c("a-icon", {
                    attrs: {
                      type: _vm.leftSideHide ? "menu-unfold" : "menu-fold"
                    },
                    on: { click: _vm.switchLeftSide }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "dl",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTabOper,
              expression: "showTabOper"
            }
          ],
          staticStyle: { left: "220px", top: "80px" },
          attrs: { id: "contextMenu" }
        },
        [
          _c("dd", [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.removeOneTab(_vm.activeIndex, "remove")
                  }
                }
              },
              [_vm._v("关闭当前")]
            )
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: { click: _vm.removeOtherTab }
              },
              [_vm._v("关闭其他")]
            )
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: { click: _vm.removeAllTab }
              },
              [_vm._v("全部关闭")]
            )
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: { click: _vm.refreshCurTab }
              },
              [_vm._v("刷新当前")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "角色切换",
            visible: _vm.modalRoleShow,
            maskClosable: false,
            destroyOnClose: true,
            footer: null
          },
          on: {
            cancel: function($event) {
              _vm.modalRoleShow = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "spaceCenter" },
            _vm._l(_vm.roleList, function(item) {
              return _c(
                "div",
                {
                  key: item.roleCode,
                  staticClass: "role-radio",
                  class: {
                    "role-radio-active": _vm.roleActive(item),
                    "role-radio-disabled": item.disabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.switchRole(item)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(item.roleName) + "\n        ")]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52a25f15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a25f15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/menu/menu-bar.vue
// module id = vhR9
// module chunks = 1